// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3814
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { FeatureLine } from "../enums/feature_line";

// Event_name: 'send.dash_invite_modal'
// Description: User submit invite request (e.g. clicking "invite" button) from Dash tean invite modal
// Owner: otc-growth
export type Send_DashInviteModal = PAPEventGeneric<
  'dash',
  'send',
  'dash_invite_modal',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Boolean event property that is set to true for Dash for Business (dfb) users.
    isDfbUserV2?: boolean;
    // This boolean field indicates if the user is a team admin or not
    isTeamAdmin?: boolean;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // The number of emails/users entered in Dash team invite form. The invite request has the potential to fail or succeed (e.g. request could fail because of network error), and this property tracks the number of users included within the invite request.
    dashInviteCount?: number;
    // The number of invited users that do not have an existing Dropbox account.
    greenfieldInviteCount?: number;
  }
>;

export function PAP_Send_DashInviteModal(properties?: Send_DashInviteModal['properties']): Send_DashInviteModal {
  return <Send_DashInviteModal>{
    class: 'dash',
    action: 'send',
    object: 'dash_invite_modal',
    properties,
  };
}
